var exports = {
  "l": "x127c5a35--32d164--phone",
};

module.exports = exports;
